<template>
  <div class="param-page">
    <div class="toolbar">
      <el-button type="primary" icon="el-icon-plus" @click="openEdit()">新增参数</el-button>
    </div>
    <el-table :data="list" border v-loading="loading">
      <el-table-column prop="paramCode" label="参数编码" min-width="180" />
      <el-table-column prop="paramName" label="参数名称" min-width="180" />
      <el-table-column prop="paramValue" label="参数值" min-width="160" show-overflow-tooltip />
      <el-table-column prop="remark" label="备注" min-width="200" show-overflow-tooltip />
      <el-table-column label="操作" width="100" fixed="right">
        <template slot-scope="{ row }">
          <el-button type="text" @click="openEdit(row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :title="form.id ? '编辑参数' : '新增参数'" :visible.sync="visible" width="520px">
      <el-form :model="form" label-width="100px">
        <el-form-item label="参数编码" required>
          <el-input v-model="form.paramCode" :disabled="!!form.id" placeholder="如：Inventory-Init" />
        </el-form-item>
        <el-form-item label="参数名称" required>
          <el-input v-model="form.paramName" placeholder="显示名称" />
        </el-form-item>
        <el-form-item label="参数值">
          <el-input v-model="form.paramValue" placeholder="参数值" />
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="form.remark" type="textarea" :rows="2" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="visible=false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="save">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { listParams, saveParam } from '../../api/sys'

export default {
  name: 'SysParam',
  data() {
    return {
      loading: false,
      saving: false,
      list: [],
      visible: false,
      form: {}
    }
  },
  created() {
    this.load()
  },
  methods: {
    async load() {
      this.loading = true
      try {
        const res = await listParams()
        this.list = res.data || []
      } finally {
        this.loading = false
      }
    },
    openEdit(row) {
      this.form = row
        ? { ...row }
        : { id: null, paramCode: '', paramName: '', paramValue: '', remark: '' }
      this.visible = true
    },
    async save() {
      const f = this.form
      if (!f.paramCode || !f.paramName) {
        return this.$message.warning('请填写参数编码和名称')
      }
      this.saving = true
      try {
        await saveParam(f)
        this.$message.success('已保存')
        this.visible = false
        this.load()
      } finally {
        this.saving = false
      }
    }
  }
}
</script>

<style scoped>
.param-page { padding: 4px 0; }
.toolbar { margin-bottom: 12px; }
</style>
